import { Component } from '@angular/core';

@Component({
  selector: 'app-pok-portal',
  templateUrl: './pok-portal.component.html',
  styles: [],
  standalone: false,
})
export class PokPortalComponent {}
